<span id="appVersion" class="hidden-information">{{ version }}</span>
<span id="appEnvironment" class="hidden-information">{{ environment }}</span>
@if (initializationFinished()) {
  <router-outlet/>
} @else {
  <div class="container h-100 d-flex">
    <mat-spinner class="m-auto"/>
  </div>
}
